// extracted by mini-css-extract-plugin
export default {"zoomModal":"C2-z","image":"D2-z","button":"E2-z","isOverlayShown":"F2-z"};